import { SelectOption } from 'components/Inputs/DropdownChecbox/DropdownCheckbox';

export const deposit_schedule: SelectOption[] = [
	{ label: 'First Banking Day', value: 'FIRST' },
	{ label: 'Second Banking Day', value: 'SECOND' },
];
